<template>
  <ul class="accountMenu-wrapper">
    <li
        v-for="(item, index) in menuList"
        :key="index"
        :class="{ 'current': item.pathName === routeName }"
        @click="routerGo(item.pathName)"
    >
      {{ item.title }}<span v-show="item.title === '投递记录' && noViewed && userType !== 1" class="noViewed">{{ noViewed }}</span>
    </li>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'accountMenu',
  data() {
    return {
      pMenuList: [ // 个人账户导航菜单列表
        { title: '账户中心', pathName: 'pUserCenter' },
        { title: '我的简历', pathName: 'pResume' },
        { title: '我的报考', pathName: 'pExamine' },
        { title: '人力资源服务', pathName: 'pDispatch' },
        { title: '投递记录', pathName: 'pRecord' },
        { title: '安全中心', pathName: 'pSafe' }
      ],
      cMenuList: [ // 企业账户账户导航菜单列表
        { title: '账户中心', pathName: 'cUserCenter' },
        { title: '企业信息', pathName: 'cInfor' },
        { title: '搜索简历', pathName: 'cFindResume' },
        { title: '招聘管理', pathName: 'cRecruitment' },
        { title: '投递记录', pathName: 'cRecord' },
        { title: '安全中心', pathName: 'cSafe' }
      ],
      aMenuList: [ // 机关事业单位账户导航菜单列表
        { title: '账户中心', pathName: 'aUserCenter' },
        { title: '企业信息', pathName: 'aInfor' },
        { title: '搜索简历', pathName: 'aFindResume' },
        { title: '招聘管理', pathName: 'aRecruitment' },
        { title: '人力资源服务', pathName: 'aLabour' },
        { title: '投递记录', pathName: 'aRecord' },
        { title: '安全中心', pathName: 'aSafe' }
      ]
    };
  },
  props: {
    userType: {
      type: Number,
      default: -1
    }
  },
  computed: {
    ...mapGetters(['noViewed']),
    // 当前路由name
    routeName() {
      return this.$route.name;
    },
    menuList() {
      if (this.userType === 1) {
        return this.pMenuList;
      } else if (this.userType === 2) {
        return this.cMenuList;
      } else if (this.userType === 3) {
        return this.aMenuList;
      } else {
        return [];
      }
    }
  },
  mounted() {
    if (this.userType !== 1) {
      this.$store.dispatch('setNum');
      this.$store.dispatch('setRecordNum');
    }
  },
  methods: {
    // 路由跳转
    routerGo(pathName) {
      if (pathName === 'cRecord' || pathName === 'aRecord') {
        this.$store.dispatch('setRecordNum');
      }
      this.$router.push({ name: pathName });
    }
  }
};
</script>

<style lang="sass" rel="stylesheet/sass" scoped>
@import "AccountMenu.sass"
</style>
